import * as React from "react";
import "./Divider.scss";

export const Divider = () => <div className="divider" />;
